import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./BusPreBook.css";
import { BsInfoCircleFill } from "react-icons/bs";
import { CiLocationOn } from "react-icons/ci";
import { FaBus, FaChevronLeft } from "react-icons/fa";
import { Link } from "react-router-dom";
import HotelPromoCodes from "../../HotelsNew/HotelPreBooking/HotelPromoCodes";
import {
  FaPlusCircle,
  FaMinusCircle,
  FaChevronDown,
  FaShieldAlt,
} from "react-icons/fa";
// import BusPromoCodes from "./BusPromoCodes";
import { FaArrowLeft } from "react-icons/fa";
import axios from "axios";
import { useLocation, useSearchParams } from "react-router-dom";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import BusPreBookSkeleton from "./BusPreBookSkeleton";
import BusReviewPassenger from "./BusReviewPage";
import PromoCode from "../../Flight/FlightDetail/PromoCode";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const BusPreBook = () => {
  const [details, setDetails] = useState({
    origin: "",
    destination: "",
    departureTime: "",
    arrivalTime: "",
    boardingTime: "",
    droppingTime: "",
    seatFare: "",
  });

  const [fareSummary, setFareSummary] = useState({
    baseFare: "",
    taxes: "",
    discount: "",
  });

  const [showGSTFields, setShowGSTFields] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedOption, setSelectedOption] = useState("yes");
  const [preBusBookDetail, setPreBusBookDetail] = useState("");
  const [storeDataDetails, setStoreDataDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [blockRequestData, setBlockRequestData] = useState(null);
  const [travellers, setTravellers] = useState([]);
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [openBusReview, setOpenBusReview] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const location = useLocation();
  const [searchParams] = useSearchParams();

  // Get tokenId from URL
  const tokenId = searchParams.get("tokenId");
  console.log("TokenId from URL:", tokenId);

  // Get payload if passed via navigate state
  const storePayload = location.state?.storePayload;
  console.log("StorePayload from navigate:", storePayload);
  console.log("Travllers", travellers);
  // update traveller input dynamically
  const handleTravellerChange = (idx, field, value) => {
    const updated = [...travellers];
    updated[idx][field] = value;

    setTravellers(updated);
  };

  // validation logic
  const validate = () => {
    let newErrors = {};

    travellers.forEach((t, idx) => {
      if (!t.title) {
        newErrors[`title-${idx}`] = "Select title"; // For desktop
        newErrors[`gender-${idx}`] = "Select gender"; // For mobile
      }
      if (!t.firstName) newErrors[`firstName-${idx}`] = "First name required";
      if (!t.lastName) newErrors[`lastName-${idx}`] = "Last name required";
      if (!t.age || isNaN(t.age) || t.age < 1)
        newErrors[`age-${idx}`] = "Enter valid age";
      // if (!t.gender) newErrors[`gender-${idx}`] = "Select gender";
    });

    if (!mobile) newErrors.mobile = "Mobile number is required";
    else if (!/^[6-9]\d{9}$/.test(mobile))
      newErrors.mobile = "Enter valid 10-digit mobile";

    if (!email) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
      newErrors.email = "Enter valid email";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Fetch StoreData details with TokenId
  useEffect(() => {
    if (!tokenId && !storePayload) return; // dono missing -> exit
    setLoading(true); // API start → show skeleton

    if (tokenId) {
      axios
        .post("https://admin.travelsdata.com/api/Bus/GetData", {
          TokenId: Number(tokenId),
        })
        .then((res) => {
          if (res.data?.data) {
            const d = res.data.data;

            setDetails({
              origin: d.Origin,
              destination: d.Destination,
              departureTime: d.DepartureTime,
              arrivalTime: d.ArrivalTime,
              boardingTime: d.BoardingTimeAddress,
              droppingTime: d.DroppingTime,
              boardingLocation: d.BoardingAddress,
              droppingLocation: d.DroppingAddress,
              operator: d.TravelName,
              busType: d.BusType,
              seatFare: d.SeatFare,
              noOfPassengers: d.NoofPassengers,
            });

            const travellersData = Array.from(
              { length: d.NoofPassengers },
              (_, i) => {
                const seat = d.Seats[i]?.SeatName ?? `S${i + 1}`;
                const fare = d.Seats[i]?.SeatFare ?? 0;
                return {
                  seat,
                  fare,
                  title: "",
                  firstName: "",
                  lastName: "",
                  age: "",
                };
              }
            );

            setTravellers(travellersData);
            localStorage.setItem("busData", JSON.stringify(d));
            setStoreDataDetails(d);
          }
        })
        .catch((err) => {
          console.error("GetData API error:", err);
        })
        .finally(() => {
          setLoading(false); // ✅ hide skeleton after success or error
        });
    } else if (storePayload) {
      setStoreDataDetails(storePayload);
      setLoading(false); // ✅ hide skeleton when payload is passed directly
    }
  }, [tokenId, storePayload]);

  const navigate = useNavigate();

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const [paymentInitializing, setPaymentInitializing] = useState(false);
  const [bookingProcessing, setBookingProcessing] = useState(false);

  const handlePayment = async () => {
    setPaymentInitializing(true); // Start payment initialization

    const res = await loadRazorpayScript();
    if (!res) {
      Swal.fire({
        icon: "error",
        title: "Razorpay SDK Failed",
        text: "Please refresh and try again.",
      });
      setPaymentInitializing(false);
      return;
    }

    try {
      setOpenBusReview(false);

      // ✅ STEP 1: Calculate final payable amount (with coupon discount if applied)
      const baseAmount = parseInt(totalFare || 0);

      const finalAmount = Math.round(
        baseAmount - (selectedCoupon ? selectedCoupon.discount : 0)
      );

      // ✅ STEP 2: Create Razorpay order
      const { data: orderData } = await axios.post(
        "https://admin.travelsdata.com/api/Bus/CreateOrder",
        {
          amount: finalAmount,
        }
      );

      if (orderData.success === false) {
        Swal.fire({
          icon: "error",
          title: "Order Creation Failed",
          text: "Could not initiate payment. Please try again.",
        });
        setPaymentInitializing(false);
        return;
      }

      // ✅ STEP 3: Razorpay options
      const options = {
        key: orderData.data.key,
        amount: orderData.data.amount,
        currency: orderData.data.currency,
        name: "Innovate Blues",
        description: "Innovate Blues Bus Booking",
        image: "/Images/tripgoo.png",
        order_id: orderData.data.order_id,
        handler: async function (response) {
          try {
            // ✅ STEP 4: Verify payment
            const { data: verifyData } = await axios.post(
              "https://admin.travelsdata.com/api/Bus/VerifyPayment",
              {
                paymentId: response.razorpay_payment_id,
                orderId: response.razorpay_order_id,
                type: "web",
              }
            );

            if (verifyData.success) {
              toast.success("✅ Payment Successful!");
              setBookingProcessing(true);
              handleContinueBooking();
            } else {
              Swal.fire({
                icon: "error",
                title: "Payment Verification Failed",
                text: "Please contact support.",
              });
            }
          } catch (verifyErr) {
            console.error("Verification error:", verifyErr);
            Swal.fire({
              icon: "error",
              title: "Verification Error",
              text: "An error occurred while verifying your payment.",
            });
          } finally {
            setPaymentInitializing(false);
          }
        },
        prefill: {
          name: "Innovate Blues",
          email: "support@innovateblues.com",
          contact: "+91 9718278968",
        },
        theme: { color: "#1d489f" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
      setPaymentInitializing(false); // Hide loading when Razorpay modal opens
    } catch (err) {
      console.error("Order creation error:", err);
      Swal.fire({
        icon: "error",
        title: "Payment Error",
        text: "Something went wrong while creating the order.",
      });
      setPaymentInitializing(false);
    }
  };

  const handleContinueBooking = async () => {
    if (!storeDataDetails?.Seats || storeDataDetails.Seats.length === 0) {
      toast.error(
        "No seat data available. Please go back and select seats again."
      );
      return;
    }
    setPaymentInitializing(true);
    // Use the exact seat objects from storePayload
    const selectedSeats = storeDataDetails.Seats;

    // Dynamic passenger mapping
    const passengers = travellers.map((t, idx) => {
      const seat = selectedSeats[idx]; // one-to-one mapping
      return {
        LeadPassenger: idx === 0,
        PassengerId: 0,
        Gender: t.title?.toLowerCase().includes("mr") ? 1 : 2,
        Title: t.title,
        Address: t.address || "N/A",
        Age: Number(t.age),
        Email: email,
        FirstName: t.firstName,
        LastName: t.lastName,
        Gender: t.title?.toLowerCase().includes("mr") ? 1 : 2,
        Phoneno: mobile,
        Seat: seat, // Full dynamic seat object
      };
    });

    // Final payload (exact like your sample)
    const payload = {
      UserEmail: email,

      UserPhone: mobile,
      Type: "web",
      Origin: storeDataDetails.Origin,
      Destination: storeDataDetails.Destination,
      TraceId: storeDataDetails.TraceId,
      ResultIndex: storeDataDetails.ResultIndex,
      BoardingPointId: storeDataDetails.BoardingPointId,
      DroppingPointId: storeDataDetails.DroppingPointId,
      Passenger: passengers,
      TotalFare: totalFare,
      CouponId: selectedCoupon ? selectedCoupon.id : 0,
    };

    console.log("Dynamic Block Payload:", payload);

    try {
      setConfirmLoading(true);
      const blockRes = await axios.post(
        "https://admin.travelsdata.com/api/Bus/Block",
        payload
      );

      if (blockRes.data?.success) {
        console.log("Block API Success:", blockRes.data);
        // setBlockRequestData(payload);
      }

      const bookRes = await axios.post(
        "https://admin.travelsdata.com/api/Bus/Book",
        payload
      );

      if (bookRes.data?.success) {
        toast.success("Booking confirmed successfully!");
        setOpenBusReview(false);
        // Extract TraceId and BusId
        setPaymentInitializing(false);
        const { TraceId, BusId } = bookRes.data.data.BookResult;
        localStorage.setItem(
          "busBookingData",
          JSON.stringify({ TraceId, BusId })
        );
        navigate("/busvoucher");
      } else {
        toast.error(bookRes.data?.message || "Failed to confirm booking.");
        setPaymentInitializing(false);
      }
    } catch (err) {
      console.error("API Error:", err);
      toast.error("Something went wrong, please try again.");
      setPaymentInitializing(false);
    }
  };
  // HANDLE SUBMIT
  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      setOpenBusReview(true); // only open modal now
    } else {
      console.log("Validation failed", errors);
    }
    setConfirmLoading(false); // hide loader
  };

  const totalFare = travellers.reduce(
    (sum, t) => sum + parseFloat(t.fare || 0),
    0
  );

  // Format bus journey duration
  const formatDuration = (departureTime, arrivalTime) => {
    const departure = new Date(departureTime);
    const arrival = new Date(arrivalTime);

    let diffMs = arrival.getTime() - departure.getTime();

    // if arrival is earlier than departure, assume arrival next day
    if (diffMs < 0) {
      diffMs += 24 * 60 * 60 * 1000;
    }

    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    const minutes = totalMinutes % 60;

    const paddedHours = String(hours).padStart(2, "0");
    const paddedMinutes = String(minutes).padStart(2, "0");

    return days > 0
      ? `${days}d ${paddedHours}h ${paddedMinutes}m`
      : `${paddedHours}h ${paddedMinutes}m`;
  };

  const insuranceItems = [
    {
      icon: "/Images/buses/health-report.png",
      title: "Accidental Medical Expenses Reimbursement",
      value: "₹150000",
    },
    {
      icon: "/Images/buses/lost-items.png",
      title: "Total loss of Baggage and Personal Effects",
      value: "₹5000",
    },
    {
      icon: "/Images/buses/cancelled.png",
      title: "Trip Cancellation & Interruption",
      value: "₹1500",
    },
    {
      icon: "/Images/buses/hospital.png",
      title: "Hospital Daily Allowance",
      value: "₹500/day",
      sub: "Maximum up to ₹3,500",
    },
    {
      icon: "/Images/buses/coffin.png",
      title: "Accidental Death Benefit",
      value: "₹600000",
    },
  ];

  const [coupons, setCoupons] = useState([]);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [loadingCoupons, setLoadingCoupons] = useState(true);
  const [errorCoupons, setErrorCoupons] = useState(null);

  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const payload = { type: "bus" };
        const response = await axios.post(
          "https://admin.travelsdata.com/api/User/CouponCode",
          payload
        );

        if (response.data?.success) {
          setCoupons(response.data.data || []);
        } else {
          setErrorCoupons("Failed to fetch coupons");
        }
      } catch (err) {
        console.error("Error fetching coupons:", err);
        setErrorCoupons("Error fetching data");
      } finally {
        setLoadingCoupons(false);
      }
    };

    fetchCoupons();
  }, []);

  return (
    <>
      {loading ? (
        <BusPreBookSkeleton />
      ) : (
        <div>
          <div className="busPreBook" style={{ position: "relative" }}>
            <div
              className="busPreBooking_MainBg"
              style={{ height: "150px" }}
            ></div>
            <div className="busPreBooking_Main">
              <div className="busPreBooking_Containers">
                <Container>
                  <Row>
                    <Col md={9}>
                      <div className="busPreBooking_ReviewBooking">
                        <div className="busPreBooking_reviewBook">
                          <Link to="/buslisting">
                            <span style={{ color: "white" }}>
                              <FaChevronLeft />
                            </span>
                          </Link>
                          <h3>Review Your Booking</h3>
                        </div>
                      </div>

                      <div className="busPreBooking_busContainor">
                        <div className="busPreBooking_busDetails">
                          <div className="busPreBooking-name">Bus Details</div>
                        </div>

                        <Row className="busPreBooking_rowCols">
                          {/* Column 1: Route Info */}
                          <Col md={3}>
                            <div className="busPreBooking-route">
                              {/* <img src="/bus-icon.png" alt="Bus" className="busPreBooking-busIcon" /> */}
                              <span className="busPreBooking-busIcon">
                                <FaBus />
                              </span>
                              <div>
                                <div className="busPreBooking-routeTitle">
                                  {details.origin} → {details.destination}
                                </div>
                                <div className="busPreBooking-dateTag">
                                  {moment(details.departureTime).format(
                                    "ddd, DD MMM"
                                  )}
                                </div>
                              </div>
                            </div>
                          </Col>

                          {/* Column 2: Time & Duration */}
                          <Col md={4}>
                            <div className="busPreBooking-timeBlock">
                              <div className="busPreBooking-timeItem">
                                <div className="busPreBooking-timeLabel">
                                  Departure Time
                                </div>
                                <div className="busPreBooking-timeValue">
                                  {new Date(
                                    details.departureTime
                                  ).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })}
                                </div>
                              </div>

                              <div className="busPreBooking-routeVisualBlock">
                                <div className="busPreBooking-lineWrapper">
                                  <span className="busPreBooking-circle" />
                                  <span className="busPreBooking-line" />
                                  {/* <span className="busPreBooking-busIconInline">🚌</span> */}
                                  <span className="busPreBooking-line" />
                                  <span className="busPreBooking-circle" />
                                </div>
                                <div className="busPreBooking-duration">
                                  {" "}
                                  {formatDuration(
                                    details.departureTime,
                                    details.arrivalTime
                                  )}
                                </div>
                              </div>

                              <div className="busPreBooking-timeItem">
                                <div className="busPreBooking-timeLabel">
                                  Arrival Time
                                </div>
                                <div className="busPreBooking-timeValue">
                                  {new Date(
                                    details.arrivalTime
                                  ).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })}
                                </div>
                              </div>
                            </div>
                          </Col>

                          {/* Column 3: Seat Info */}
                          <Col md={2}>
                            <div className="busPreBooking-timeItem">
                              <div className="busPreBooking-timeLabel">
                                Seat no(s)
                              </div>
                              <div className="busPreBooking-seatTags">
                                {travellers.length > 0 ? (
                                  travellers.map((t, i) => (
                                    <span
                                      key={i}
                                      className="busPreBooking-seatTag"
                                    >
                                      {t.seat} {""}
                                    </span>
                                  ))
                                ) : (
                                  <span>-</span>
                                )}
                              </div>
                            </div>
                          </Col>
                          {/* Column 4: Passenger Count */}
                          <Col md={3}>
                            <div className="busPreBooking-timeItem">
                              <div className="busPreBooking-timeLabel">
                                No of Passenger(s)
                              </div>
                              <div className="busPreBooking-timeValue">
                                {" "}
                                {details.noOfPassengers}
                              </div>
                            </div>
                          </Col>
                        </Row>

                        {/* Address Section */}
                        <Row className="busPreBooking-addressRow mt-3">
                          {/* Boarding Block */}
                          <Col md={8}>
                            <div className="busPreBooking-addressTimeBox">
                              <div className="busPreBooking-addressTimeLabel">
                                Boarding Time & Address
                              </div>
                              <div style={{ display: "flex" }}>
                                <div className="busPreBooking-time">
                                  <strong>
                                    {new Date(
                                      details.boardingTime
                                    ).toLocaleTimeString([], {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true,
                                    })}
                                  </strong>
                                </div>
                                <div className="busPreBooking-address">
                                  {" "}
                                  {details.boardingLocation}
                                </div>
                              </div>
                            </div>
                            {/* Dropping Block */}
                            <div className="busPreBooking-addressTimeBox">
                              <div className="busPreBooking-addressTimeLabel">
                                Dropping Time & Address
                              </div>
                              <div style={{ display: "flex" }}>
                                <div className="busPreBooking-time">
                                  <strong>
                                    {new Date(
                                      details.droppingTime
                                    ).toLocaleTimeString([], {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true,
                                    })}
                                  </strong>
                                </div>
                                <div className="busPreBooking-address">
                                  {details.droppingLocation}
                                </div>
                              </div>
                            </div>
                          </Col>

                          <Col md={4} className="busPreBooking-busOperatorCol">
                            <div className="busPreBooking-addressTimeBox">
                              <div className="busPreBooking-addressTimeLabel">
                                Bus Operator
                              </div>
                              <div>
                                <strong>{details.operator}</strong>
                                <div className="busPreBooking-address">
                                  {details.busType}
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>

                      {/* <div className="busPreBooking_GSTInfo">       
                          <Row>
                            <Col sm={12}>
                              <div className="">
                                <label className="busPreBooking_GSTContainer">
                                  <span><FaPlusCircle /></span>
                                  <span className="busPreBooking_checkboxLabel">
                                    <span className="busPreBooking_boldFont">
                                      I have a GST number <span style={{ color: "#9b9b9b" }}>(Optional)</span>
                                    </span>
                                  </span>
                                </label>
                                  <div className="busPreBooking_gstFields">
                                    <Row className="busPreBooking_adultItemRow">
                                      <Col sm={6}>
                                        <label className="busPreBooking_label">Company Name</label>
                                        <input className="busPreBooking_input" type="text" placeholder="Company Name" />
                                      </Col>
                                      <Col sm={6} className="">
                                        <label className="busPreBooking_label">GST No</label>
                                        <input className="busPreBooking_input" type="text" placeholder="GST No" />
                                      </Col>
                                    </Row>
                                  </div>
                              
                              </div>
                            </Col>
                          </Row>
                        </div> */}

                      {/* Travel Insurance  */}

                      {/* <div className="busPreBooking_insurance-section">
  <div className="busPreBooking_insurance-header" onClick={() => setShowDetails(!showDetails)}>
    <div className="busPreBooking_insurance-title">
      <span role="img" aria-label="shield" className="busPreBooking_insurance-icon">
        <span><FaShieldAlt /></span>
      </span>
      <span>Add Travel Insurance and Secure your Trip with ACKO Travel Insurance for ₹15/Person</span>
    </div>
    <div className="busPreBooking_insurance-logo">
      <FaChevronDown className={`busPreBooking_chevron-icon ${showDetails ? 'busPreBooking_rotate' : ''}`} />
    </div>
  </div>

  <div className="busPreBooking_InsurancePadding">
    {showDetails && (
      <div className="busPreBooking_insurance-body">
        <p className="busPreBooking_insurance-terms">
          (Upon Selecting Travel Insurance, You accept the <a href="#">Terms and Conditions</a> of the travel insurance policy)
        </p>

        <div className="busPreBooking_insurance-cards">
            {insuranceItems.map((item, i) => (
            <div className="busPreBooking_insurance-card" key={i}>
                {item.icon && (
                <div className="busPreBooking_insurance-card-icon">
                    <img src={item.icon} alt="icon" />
                </div>
                )}
                <div className="busPreBooking_insurance-card-title">{item.title}</div>
                <div className="busPreBooking_insurance-card-value">Insured : {item.value}</div>
                {item.sub && (
                <div className="busPreBooking_insurance-card-sub">{item.sub}</div>
                )}
            </div>
            ))}
        </div>

        
      </div>
    )}
  </div>

<div style={{padding:'2px 20px'}}>
<div className="busPreBooking_insurance-options">
          <label>
            <input
              type="radio"
              name="insurance"
              checked={selectedOption === "yes"}
              onChange={() => setSelectedOption("yes")}
            />
            <span className="busPreBooking_insurance-radio-label">
              Yes, I want to secure my trip with insurance.
              <div className="busPreBooking_insurance-highlight">More than 36% of our customers choose to secure their trip.</div>
            </span>
          </label>

          <label>
            <input
              type="radio"
              name="insurance"
              checked={selectedOption === "no"}
              onChange={() => setSelectedOption("no")}
            />
            <span className="busPreBooking_insurance-radio-label">No, I do not want to insure my trip</span>
          </label>
        </div>
</div>

</div> */}

                      <div className="busPreBooking_GSTInfo">
                        <Row>
                          <Col sm={12}>
                            <div>
                              <label
                                className="busPreBooking_GSTContainer"
                                style={{ cursor: "pointer" }}
                                onClick={() => setShowGSTFields(!showGSTFields)}
                              >
                                <span>
                                  {showGSTFields ? (
                                    <FaMinusCircle
                                      style={{ color: "#d9534f" }}
                                    />
                                  ) : (
                                    <FaPlusCircle
                                      style={{ color: "#5cb85c" }}
                                    />
                                  )}
                                </span>
                                <span className="busPreBooking_checkboxLabel">
                                  <span className="busPreBooking_boldFont">
                                    I have a GST number{" "}
                                    <span style={{ color: "#9b9b9b" }}>
                                      (Optional)
                                    </span>
                                  </span>
                                </span>
                              </label>

                              {showGSTFields && (
                                <div className="busPreBooking_gstFields">
                                  <Row className="busPreBooking_adultItemRow">
                                    <Col sm={6}>
                                      <label className="busPreBooking_label">
                                        Company Name
                                      </label>
                                      <input
                                        className="busPreBooking_input"
                                        type="text"
                                        placeholder="Company Name"
                                      />
                                    </Col>
                                    <Col sm={6}>
                                      <label className="busPreBooking_label">
                                        GST No
                                      </label>
                                      <input
                                        className="busPreBooking_input"
                                        type="text"
                                        placeholder="GST No"
                                      />
                                    </Col>
                                  </Row>
                                </div>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </div>

                      <div className="busTravellerDetails-container">
                        <div className="busTravellerDetails-header">
                          <span>Travellers Details</span>
                          <span className="busTravellerDetails-note">
                            <i className="fas fa-id-card"></i> Name should be
                            same as in Government ID proof
                          </span>
                        </div>

                        {travellers.map((traveller, idx) => (
                          <div className="busTravellerDetails-row" key={idx}>
                            <div className="busTravellerDetails-label">
                              Adult
                            </div>

                            <div className="busTravellerDetails-input-fieldWrapper">
                              <select
                                className="busTravellerDetails-input busTravellerDetails-title"
                                value={traveller.title}
                                onChange={(e) =>
                                  handleTravellerChange(
                                    idx,
                                    "title",
                                    e.target.value
                                  )
                                }
                              >
                                <option value="">Title</option>
                                <option>Mr</option>
                                <option>Mrs</option>
                                <option>Ms</option>
                              </select>
                              {errors[`title-${idx}`] && (
                                <div className="error">
                                  {errors[`title-${idx}`]}
                                </div>
                              )}
                            </div>

                            <div className="busTravellerDetails-input-fieldWrapper">
                              <input
                                className="busTravellerDetails-input"
                                placeholder="Enter First Name"
                                value={traveller.firstName}
                                onChange={(e) =>
                                  handleTravellerChange(
                                    idx,
                                    "firstName",
                                    e.target.value
                                  )
                                }
                              />
                              {errors[`firstName-${idx}`] && (
                                <div className="error">
                                  {errors[`firstName-${idx}`]}
                                </div>
                              )}
                            </div>

                            <div className="busTravellerDetails-input-fieldWrapper">
                              <input
                                className="busTravellerDetails-input"
                                placeholder="Enter Last Name"
                                value={traveller.lastName}
                                onChange={(e) =>
                                  handleTravellerChange(
                                    idx,
                                    "lastName",
                                    e.target.value
                                  )
                                }
                              />
                              {errors[`lastName-${idx}`] && (
                                <div className="error">
                                  {errors[`lastName-${idx}`]}
                                </div>
                              )}
                            </div>

                            <div className="busTravellerDetails-input-fieldWrapper">
                              <input
                                className="busTravellerDetails-input busTravellerDetails-age"
                                placeholder="Age"
                                value={traveller.age}
                                onChange={(e) =>
                                  handleTravellerChange(
                                    idx,
                                    "age",
                                    e.target.value
                                  )
                                }
                              />
                              {errors[`age-${idx}`] && (
                                <div className="error">
                                  {errors[`age-${idx}`]}
                                </div>
                              )}
                            </div>

                            {/* ✅ Seat info from API */}
                            <div className="busTravellerDetails-seatWrapper">
                              <div className="busTravellerDetails-seatLabel">
                                Seat Name
                              </div>
                              <div className="busTravellerDetails-seatValue">
                                {traveller.seat || `Seat ${idx + 1}`}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="busTravellerDetails-wrapper">
                        <div className="busTravellerDetails-mobileWrapper">
                          <div>Enter Your Mobile Number</div>
                          <p>
                            Your mobile number will only be used for bus-related
                            communication.
                          </p>
                          <div className="busTravellerDetails-mobileInput">
                            <i className="fas fa-phone"></i>
                            <input
                              type="text"
                              placeholder="Mobile Number"
                              value={mobile}
                              onChange={(e) => setMobile(e.target.value)}
                            />
                          </div>
                          {errors.mobile && (
                            <div className="error">{errors.mobile}</div>
                          )}
                        </div>

                        <div className="busPreBooking_email-section">
                          <label className="busPreBooking_email-label">
                            Email Address
                          </label>
                          <span className="busPreBooking_email-info">
                            Your ticket will be sent to this email address
                          </span>
                          <div className="busTravellerDetails-mobileInput">
                            <i className="fas fa-envelope"></i>
                            <input
                              type="email"
                              placeholder="Enter your Email ID"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                          </div>
                          {errors.email && (
                            <div className="error">{errors.email}</div>
                          )}
                        </div>
                      </div>
                    </Col>

                    <Col md={3}>
                      <div className="hotelFinalBooking_priceSummary">
                        <div className="hotelFinalBooking_fareSummary">
                          <div>Fare Summary</div>
                          <div>{details.noOfPassengers} Passenger(s)</div>
                        </div>

                        <div className="hotelFinalBooking_BasefareSummary">
                          <div>Base Fare * {details.noOfPassengers}</div>
                          <div>
                            ₹{" "}
                            {storeDataDetails?.Seats?.reduce(
                              (total, seat) =>
                                total + (seat?.Price?.BasePrice || 0),
                              0
                            )}
                          </div>
                        </div>
                        <div className="hotelFinalBooking_BasefareSummary">
                          <div>Taxes</div>
                          <div>
                            ₹{" "}
                            {storeDataDetails?.Seats?.reduce(
                              (total, seat) => total + (seat?.Price?.Tax || 0),
                              0
                            )}
                          </div>
                        </div>

                        {selectedCoupon?.discount > 0 && (
                          <div className="hotelFinalBooking_BasefareSummary">
                            <div>Discount -</div>
                            <div>₹ {Math.round(selectedCoupon.discount)}</div>
                          </div>
                        )}

                        <div className="hotelFinalBooking_PayAmt">
                          <div>You Pay: -</div>
                          <div>
                            ₹{" "}
                            {Math.round(
                              totalFare -
                                (selectedCoupon ? selectedCoupon.discount : 0)
                            )}
                          </div>
                        </div>
                        {/* <button onClick={handleHotelBookNow} className="hotelFinalBooking_continueBtn">Continue</button> */}
                        <button
                          onClick={handleSubmit}
                          className="hotelFinalBooking_continueBtn"
                        >
                          Continue
                        </button>

                        {openBusReview && (
                          <BusReviewPassenger
                            travellers={travellers}
                            busDetails={details}
                            totalFare={totalFare}
                            onClose={() => setOpenBusReview(false)}
                            onConfirm={handlePayment} // call block+book here
                            confirmLoading={confirmLoading} // pass loading state
                          />
                        )}

                        {/* {showModal && (
  <div className="modal-backdrop">
    <div className="modal-box">
      <h3>Seat Blocked Successfully</h3>
      <p>Do you want to confirm the booking for the following seats?</p>

<div className="seat-details">
  {travellers.map((t, idx) => (
    <div key={idx} className="seat-info">
      <strong>Seat:</strong> {t.seat} &nbsp;
      <strong>Name:</strong> {t.firstName} {t.lastName} &nbsp;
      <strong>Price:</strong> ₹{t.fare}
    </div>
  ))}
</div>


      <div className="modal-actions">
        <button className="cancel-btn" onClick={() => setShowModal(false)}>
          Cancel
        </button>
        <button
          className="confirm-btn"
          onClick={() => handleContinueBooking("book")}
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
)} */}
                      </div>
                      <div>
                        <PromoCode
                          availableCoupons={coupons}
                          onSelectCoupon={(coupon) => setSelectedCoupon(coupon)}
                        />
                      </div>
                    </Col>
                  </Row>
                  {paymentInitializing && (
                    <div
                      style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(0,0,0,0.45)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9998,
                      }}
                    >
                      <div
                        style={{
                          background: "#fff",
                          padding: "16px 20px",
                          borderRadius: 8,
                          boxShadow: "0 6px 18px rgba(0,0,0,0.2)",
                          display: "flex",
                          alignItems: "center",
                          gap: 12,
                        }}
                      >
                        <span
                          className="spinner-border"
                          role="status"
                          aria-hidden="true"
                          style={{ width: 24, height: 24 }}
                        ></span>
                        <span style={{ fontWeight: 600 }}>
                          Initializing secure payment…
                        </span>
                      </div>
                    </div>
                  )}

                  {bookingProcessing && (
                    <div
                      style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(0,0,0,0.45)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999,
                      }}
                    >
                      <div
                        style={{
                          background: "#fff",
                          padding: "24px 32px",
                          borderRadius: 12,
                          boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 16,
                          maxWidth: "400px",
                          textAlign: "center",
                        }}
                      >
                        <div
                          style={{
                            width: 48,
                            height: 48,
                            border: "4px solid #f3f3f3",
                            borderTop: "4px solid #1d489f",
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite",
                          }}
                        ></div>
                        <div>
                          <h4
                            style={{
                              margin: "0 0 8px 0",
                              color: "#333",
                              fontSize: "18px",
                            }}
                          >
                            Please wait...
                          </h4>
                          <p
                            style={{
                              margin: 0,
                              color: "#666",
                              fontSize: "14px",
                            }}
                          >
                            Your booking is almost done! We're processing your
                            reservation.
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </Container>
              </div>
            </div>
          </div>

          <div className="busPreBookMobile-wrapper">
            <div className="busPreBookMobile-header">
              <Link to="/buslisting">
                <FaArrowLeft className="busback-icon" />
              </Link>
              <span className="busPreBookMobile-headerText">
                Traveller Review
              </span>
            </div>
            <div className="busPreBookMobile-section">
              <h3 className="busPreBookMobile-heading">
                {details.origin} → {details.destination}
              </h3>
              <div className="busPreBookMobile-date">
                {moment(details.departureTime).format("ddd, DD MMM")}
              </div>

              <div className="busPreBookMobile-boardCard">
                <div className="busPreBookMobile-boardTimeRow">
                  <div className="busPreBookMobile-timeColumn">
                    <h3 className="busPreBookMobile-city">{details.origin}</h3>
                    <div className="busPreBookMobile-time">
                      {new Date(details.boardingTime).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })}
                    </div>
                    <div className="busPreBookMobile-point">
                      {details.boardingLocation}
                    </div>
                  </div>

                  <div className="busPreBookMobile-durationWrap">
                    <span className="busPreBookMobile-durationText">
                      {formatDuration(
                        details.departureTime,
                        details.arrivalTime
                      )}
                    </span>
                  </div>

                  <div className="busPreBookMobile-timeColumn">
                    <h3 className="busPreBookMobile-city">
                      {details.destination}
                    </h3>
                    <div className="busPreBookMobile-time">
                      {new Date(details.droppingTime).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })}
                    </div>
                    <div className="busPreBookMobile-point">
                      {details.droppingLocation}
                    </div>
                  </div>
                </div>

                <hr />

                <div className="busPreBookMobile-points">
                  <div className="busPreBookMobile-pickDrop">
                    <div>
                      <img src="/Images/buses/pin.png" alt="" /> Pick up
                    </div>
                    <p>
                      {" "}
                      {new Date(details.boardingTime).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })}{" "}
                      {details.boardingLocation}
                    </p>
                  </div>
                  <div className="busPreBookMobile-pickDrop">
                    <div>
                      <img src="/Images/buses/pin.png" alt="" /> Drop Point
                    </div>
                    <p>
                      {" "}
                      {new Date(details.droppingTime).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })}{" "}
                      {details.droppingLocation}
                    </p>
                  </div>
                </div>
              </div>

              <div className="busPreBookMobile-operatorCard">
                <div className="busPreBookMobile-operatorRow">
                  <span>
                    <strong>Bus Operator</strong>
                    <br />
                    {details.operator}
                  </span>
                  <span>
                    <strong>Selected Seats</strong>
                    <br />
                    <div className="busPreBooking-timeItem">
                      <div className="busPreBooking-seatTags">
                        {travellers.length > 0 ? (
                          travellers.map((t, i) => (
                            <span key={i} className="busPreBooking-seatTag">
                              {t.seat}
                            </span>
                          ))
                        ) : (
                          <span>-</span>
                        )}
                      </div>
                    </div>
                  </span>
                </div>
                <div className="busPreBookMobile-busType">
                  <strong>Bus Type</strong>
                  <br />
                  {details.busType}
                </div>
              </div>
            </div>

            <div className="busPreBookMobile-travellerSection">
              <h4 className="busPreBookMobile-travellerTitle">
                Travellar Details
              </h4>

              <div className="busPreBookMobile-travellerNote">
                <span className="busPreBookMobile-travellerNoteIcon">👤</span>
                Name should be same as in Government ID proof
              </div>

              <div className="busPreBookMobile-travellerCard">
                {travellers.map((traveller, idx) => (
                  <div key={idx}>
                    {/* Seat Header */}
                    <div className="busPreBookMobile-adultHeader">
                      <span>ADULT </span>
                      <span className="busPreBookMobile-seatTag">
                        {traveller.seat} (
                        {traveller.BerthType || traveller.SeatType || "SL"})
                      </span>
                    </div>

                    {/* Gender Selector */}
                    <div className="busPreBookMobile-genderSelector">
                      <button
                        type="button"
                        className={`busPreBookMobile-genderBtn ${
                          traveller.title === "Mr" ? "active" : ""
                        }`}
                        onClick={() =>
                          handleTravellerChange(idx, "title", "Mr")
                        }
                      >
                        Male
                      </button>
                      <button
                        type="button"
                        className={`busPreBookMobile-genderBtn ${
                          traveller.title === "Ms" ? "active" : ""
                        }`}
                        onClick={() =>
                          handleTravellerChange(idx, "title", "Ms")
                        }
                      >
                        Female
                      </button>

                      {errors[`gender-${idx}`] && (
                        <div
                          className="error"
                          style={{
                            color: "red",
                            marginTop: "4px",
                            fontSize: "12px",
                          }}
                        >
                          {errors[`gender-${idx}`]}
                        </div>
                      )}
                    </div>

                    {/* First Name */}
                    <div className="busPreBookMobile-inputGroup">
                      <label>First Name (& Middle name if any)</label>
                      <input
                        type="text"
                        placeholder="Enter First Name"
                        value={traveller.firstName || ""}
                        onChange={(e) =>
                          handleTravellerChange(
                            idx,
                            "firstName",
                            e.target.value
                          )
                        }
                      />
                      {errors[`firstName-${idx}`] && (
                        <div className="error">
                          {errors[`firstName-${idx}`]}
                        </div>
                      )}
                    </div>

                    {/* Last Name + Age */}
                    <div
                      className="busPreBookMobile-nameAgeRow"
                      style={{ width: "100%" }}
                    >
                      <div style={{ width: "40%" }}>
                        <label>Last Name</label>
                        <input
                          type="text"
                          placeholder="Enter Last Name"
                          value={traveller.lastName || ""}
                          onChange={(e) =>
                            handleTravellerChange(
                              idx,
                              "lastName",
                              e.target.value
                            )
                          }
                        />
                        {errors[`lastName-${idx}`] && (
                          <div className="error">
                            {errors[`lastName-${idx}`]}
                          </div>
                        )}
                      </div>

                      <div style={{ width: "40%" }}>
                        <label>Age</label>
                        <input
                          type="text"
                          placeholder="Enter Age"
                          value={traveller.age || ""}
                          onChange={(e) =>
                            handleTravellerChange(idx, "age", e.target.value)
                          }
                        />
                        {errors[`age-${idx}`] && (
                          <div className="error">{errors[`age-${idx}`]}</div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}

                {/* <div className="busPreBooking_insurance-section">
                  <div
                    className="busPreBooking_insurance-header"
                    onClick={() => setShowDetails(!showDetails)}
                  >
                    <div className="busPreBooking_insurance-title">
                      <span
                        role="img"
                        aria-label="shield"
                        className="busPreBooking_insurance-icon"
                      >
                        <span>
                          <FaShieldAlt />
                        </span>
                      </span>
                      <span>
                        Add Travel Insurance and Secure your Trip with ACKO
                        Travel Insurance for ₹15/Person
                      </span>
                    </div>
                    <div className="busPreBooking_insurance-logo">
                      <FaChevronDown
                        className={`busPreBooking_chevron-icon ${
                          showDetails ? "busPreBooking_rotate" : ""
                        }`}
                      />
                    </div>
                  </div>

                  <div className="busPreBooking_InsurancePadding">
                    {showDetails && (
                      <div className="busPreBooking_insurance-body">
                        <p className="busPreBooking_insurance-terms">
                          (Upon Selecting Travel Insurance, You accept the{" "}
                          <a href="#">Terms and Conditions</a> of the travel
                          insurance policy)
                        </p>

                        <div className="busPreBooking_insurance-cards">
                          {insuranceItems.map((item, i) => (
                            <div
                              className="busPreBooking_insurance-card"
                              key={i}
                            >
                              {item.icon && (
                                <div className="busPreBooking_insurance-card-icon">
                                  <img src={item.icon} alt="icon" />
                                </div>
                              )}
                              <div className="busPreBooking_insurance-card-title">
                                {item.title}
                              </div>
                              <div className="busPreBooking_insurance-card-value">
                                Insured : {item.value}
                              </div>
                              {item.sub && (
                                <div className="busPreBooking_insurance-card-sub">
                                  {item.sub}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  <div style={{ padding: "2px 20px" }}>
                    <div className="busPreBooking_insurance-options">
                      <label>
                        <input
                          type="radio"
                          name="insurance"
                          checked={selectedOption === "yes"}
                          onChange={() => setSelectedOption("yes")}
                        />
                        <span className="busPreBooking_insurance-radio-label">
                          Yes, I want to secure my trip with insurance.
                          <div className="busPreBooking_insurance-highlight">
                            More than 36% of our customers choose to secure
                            their trip.
                          </div>
                        </span>
                      </label>

                      <label>
                        <input
                          type="radio"
                          name="insurance"
                          checked={selectedOption === "no"}
                          onChange={() => setSelectedOption("no")}
                        />
                        <span className="busPreBooking_insurance-radio-label">
                          No, I do not want to insure my trip
                        </span>
                      </label>
                    </div>
                  </div>
                </div> */}

                <div className="busPreBooking_GSTInfo">
                  <Row>
                    <Col sm={12}>
                      <div>
                        <label
                          className="busPreBooking_GSTContainer"
                          style={{ cursor: "pointer" }}
                          onClick={() => setShowGSTFields(!showGSTFields)}
                        >
                          <span>
                            {showGSTFields ? (
                              <FaMinusCircle style={{ color: "#d9534f" }} />
                            ) : (
                              <FaPlusCircle style={{ color: "#5cb85c" }} />
                            )}
                          </span>
                          <span className="busPreBooking_checkboxLabel">
                            <span className="busPreBooking_boldFont">
                              I have a GST number{" "}
                              <span style={{ color: "#9b9b9b" }}>
                                (Optional)
                              </span>
                            </span>
                          </span>
                        </label>

                        {showGSTFields && (
                          <div className="busPreBooking_gstFields">
                            <Row className="busPreBooking_adultItemRow">
                              <Col sm={6}>
                                <label className="busPreBooking_label">
                                  Company Name
                                </label>
                                <input
                                  className="busPreBooking_input"
                                  type="text"
                                  placeholder="Company Name"
                                />
                              </Col>
                              <Col sm={6}>
                                <label className="busPreBooking_label">
                                  GST No
                                </label>
                                <input
                                  className="busPreBooking_input"
                                  type="text"
                                  placeholder="GST No"
                                />
                              </Col>
                            </Row>
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>

                <div className="busPreBooking_email-section">
                  <label className="busPreBooking_email-label">
                    E-mail Details
                  </label>
                  <span className="busPreBooking_email-info">
                    Your ticket will be sent to this email address
                  </span>
                  <input
                    type="email"
                    className="busPreBooking_email-input"
                    placeholder="Enter your Email ID"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {errors.email && <div className="error">{errors.email}</div>}
                </div>

                <div className="busPreBooking_email-section">
                  <label className="busPreBooking_email-label">
                    Mobile No Details
                  </label>
                  <span className="busPreBooking_email-info">
                    Your ticket will be sent to this email address
                  </span>
                  <input
                    type="phone"
                    className="busPreBooking_email-input"
                    placeholder="Enter your mobile number"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                  />
                  {errors.mobile && (
                    <div className="error">{errors.mobile}</div>
                  )}
                </div>

                <div className="busPreBookMobile-priceBar">
                  <div>
                    <div className="busPreBookMobile-guestInfo">
                      <span>Total Price</span>
                    </div>
                    <strong style={{ color: "#a7a7a7ff" }}>
                      ₹{" "}
                      {Math.round(
                        (totalFare || 0) -
                          (selectedCoupon ? selectedCoupon.discount : 0)
                      )}
                    </strong>
                  </div>
                  <button onClick={handleSubmit}>Continue</button>
                  {openBusReview && (
                    <BusReviewPassenger
                      travellers={travellers}
                      busDetails={details}
                      totalFare={totalFare}
                      onClose={() => setOpenBusReview(false)}
                      onConfirm={handlePayment} // call block+book here
                      confirmLoading={confirmLoading} // pass loading state
                    />
                  )}
                </div>
              </div>

              <div style={{ marginBottom: "70px" }}>
                <PromoCode
                  availableCoupons={coupons}
                  onSelectCoupon={(coupon) => setSelectedCoupon(coupon)}
                />
              </div>
              {paymentInitializing && (
                <div
                  style={{
                    position: "fixed",
                    inset: 0,
                    background: "rgba(0,0,0,0.45)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 9998,
                  }}
                >
                  <div
                    style={{
                      background: "#fff",
                      padding: "16px 20px",
                      borderRadius: 8,
                      boxShadow: "0 6px 18px rgba(0,0,0,0.2)",
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                    }}
                  >
                    <span
                      className="spinner-border"
                      role="status"
                      aria-hidden="true"
                      style={{ width: 24, height: 24 }}
                    ></span>
                    <span style={{ fontWeight: 600 }}>
                      Initializing secure payment…
                    </span>
                  </div>
                </div>
              )}

              {bookingProcessing && (
                <div
                  style={{
                    position: "fixed",
                    inset: 0,
                    background: "rgba(0,0,0,0.45)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 9999,
                  }}
                >
                  <div
                    style={{
                      background: "#fff",
                      padding: "24px 32px",
                      borderRadius: 12,
                      boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 16,
                      maxWidth: "400px",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        width: 48,
                        height: 48,
                        border: "4px solid #f3f3f3",
                        borderTop: "4px solid #1d489f",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                      }}
                    ></div>
                    <div>
                      <h4
                        style={{
                          margin: "0 0 8px 0",
                          color: "#333",
                          fontSize: "18px",
                        }}
                      >
                        Please wait...
                      </h4>
                      <p style={{ margin: 0, color: "#666", fontSize: "14px" }}>
                        Your booking is almost done! We're processing your
                        reservation.
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BusPreBook;
